var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 7c1.7 0 3.2.6 4.2 1.6L19 5.8C18.9 3.1 21 1 23.5 1S28 2.9 28 5.5 26 10 23.5 10c-1.4 0-2.5-.6-3.3-1.5l-7.5 2.9c.3 1.2.3 2.1-.2 3.4l5.2 3.6c1.5-1.5 3.5-2.4 5.7-2.4 4.2 0 7.5 3.3 7.5 7.5S27.7 31 23.5 31c-5 0-8.8-4.9-7-10l-5.4-3.6C10 18.4 8.5 19 7 19c-3.3 0-6-2.7-6-6s2.7-6 6-6"
})));
export default SvgIconShare;